import React, {useState} from 'react';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Password} from "primereact/password";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import GeneralUtils from "../../utils/GeneralUtils";
import {Link, useNavigate} from "react-router-dom";
import {UuserService} from "../../service/UuserService";
import {Divider} from 'primereact/divider';
import { Card } from 'primereact/card';
import SHA256 from "crypto-js/sha256";
import { Checkbox } from 'primereact/checkbox';
import UserAgreement from '../../components/UserAgreement';

const Signup = () => {

    const [title, setTitle] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [acceptedUserAgreement, setAcceptedUserAgreement] = useState(false); // KVKK onay durumu
    const [showUserAgreement, setShowUserAgreement] = useState(false); // Kullanıcı sözleşmesi modal görünürlük

    const service = new UuserService();
    const navigate = useNavigate();

    const signup = () => {
        if (GeneralUtils.isNullOrEmpty(title) || GeneralUtils.isNullOrEmpty(email) || GeneralUtils.isNullOrEmpty(password) || GeneralUtils.isNullOrEmpty(confirmPassword)) {
            return toast.warn('Lütfen tüm alanları doldurun.');
        }

        if (password !== confirmPassword) {
            return toast.warn('Şifreler eşleşmiyor. Lütfen tekrar deneyin.');
        }
        // Email regex (güncel): kullanıcı adı bölümünde harf/rakam/altçizgi/nokta/tire; domain segmentleri harf/rakam/tire; TLD en az 2 karakter
        if (/^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/.test(email) === false) {
            return toast.warn('Lütfen geçerli bir email adresi girin.');
        }

        if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password) === false) {
            return toast.warn('Lütfen geçerli bir şifre girin.');

        }

        if (!acceptedUserAgreement) {
            return toast.warn('Lütfen KVKK metnini okuyup onay kutusunu işaretleyin.');
        }

        const data = {
            title: title,
            email: email,
            password: SHA256(password).toString(),
            confirmPassword: SHA256(confirmPassword).toString(),
            // acceptedUserAgreement backend'e gönderilmek istenirse eklenebilir
            // acceptedUserAgreement: acceptedUserAgreement
        };


        setLoading(true);
        service.create(data).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                navigate('/login');
            }
            setLoading(false);
        });

    };

    const header = <div className="font-bold mb-3">Şifre belirle</div>;
    const footer = (
        <>
            <Divider/>
            <p className="mt-2">Tavsiyeler</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>En az bir küçük harf</li>
                <li>En az bir büyük harf</li>
                <li>En az bir rakam</li>
                <li>En az 8 karakter</li>
            </ul>
        </>
    );

    return (
        <div className="flex flex-column align-items-center justify-content-center" style={{margin: "5rem 0 5rem"}}>
            <div style={{
                borderRadius: '56px',
                padding: '0.3rem',
                background: 'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)'
            }}>
            <Card className="w-full surface-card py-8 px-5 sm:px-8" style={{ borderRadius: '53px' }} title="Kaydolun ve öğrenmeye başlayın">
            <div className="flex flex-column gap-4" style={{padding: "2rem", width: "500px"}}>
                <InputText value={title} onChange={(e) => setTitle(e.target.value)}
                           className="inputtext p-inputtext-sm" placeholder="Tam ad"/>
                <InputText value={email} onChange={(e) => setEmail(e.target.value)}
                           className="inputtext p-inputtext-sm" placeholder="E-posta"/>
                <Password value={password} onChange={(e) => setPassword(e.target.value)} feedback={true} toggleMask
                          className="p-inputtext-sm" placeholder="Şifre" header={header} footer={footer} promptLabel="Şifre Girin" weakLabel="Zayıf" mediumLabel="Orta" strongLabel="Güçlü"/>
                <Password placeholder="Şifreyi yeniden yazın" value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)} className="p-inputtext-sm"
                          feedback={false} toggleMask/>

                {/* KVKK Onay Kutusu */}
                <div className="flex align-items-start gap-2" style={{marginTop: '-0.5rem'}}>
                    <Checkbox
                        inputId="kvkk"
                        onChange={(e) => setAcceptedUserAgreement(!!e.checked)}
                        checked={acceptedUserAgreement}
                        binary
                        className="mt-1"
                    />
                    <label htmlFor="kvkk" style={{fontSize: '0.85rem', lineHeight: 1.4, cursor: 'pointer'}}>
                        <span>
                            <Button
                                type="button"
                                label="KVKK Aydınlatma Metni"
                                link
                                onClick={() => setShowUserAgreement(true)}
                                className="p-0 kvkk-link"
                                style={{padding: 0}}
                                aria-label="KVKK Aydınlatma Metni aç"
                                size="small"
                            />'ni okudum ve verilerimin anonim olarak işlenmesini kabul ediyorum.
                        </span>
                    </label>
                </div>

                <Button label="Kaydol" onClick={signup} size="sm" style={{width: "100%"}} loading={loading} disabled={!acceptedUserAgreement}/>

                <p>Zaten hesabınız var mı? <Link to={`/login`} style={{color: 'var(--highlight-text-color)', fontWeight: "600"}}>Oturum açın</Link></p>

            </div>
            </Card>
            </div>

            {/* Kullanıcı Sözleşmesi Dialog */}
            <UserAgreement visible={showUserAgreement} onHide={() => setShowUserAgreement(false)} />
        </div>
    );
}

export default Signup;